import React, { useEffect } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Card, Link, Typography, Stack, Button, InputAdornment, TextField, Grid } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { useOrderStatusUpdateMutation } from '../../redux/services/orders/Orders';
import { showSuccess, showError } from '../../utils/toast';

const UpdateOrders = (props) => {
    const { update, setUpdate, order, load } = props
    const [updateOrder, setUpdateOrder] = useOrderStatusUpdateMutation()
    const { register, handleSubmit, setValue, watch, control, reset, formState: { errors } } = useForm();
    useEffect(() => {
        setValue("status", order?.data?.status)
        setValue("remark", order?.data?.remark)
        console.log("updateId", order?.data?.id)
    }, [order?.data])

    const onUpdateOrdre = async (data) => {
        const body = {
            id: order?.data?.id,
            action: "both",
            status: data.status,
            remark: data.remark
        }

        try {

            const updateOrderResult = await updateOrder(body)
            console.log("updateSuccess", updateOrderResult)
            load()
            setUpdate(null)
        } catch (error) {
            console.log("error", error)
        }
    }


    useEffect(() => {

        if (setUpdateOrder.isSuccess) {
            showSuccess('Order Status Updated ',)
            setUpdateOrder.reset()

        }
        if (setUpdateOrder.isError) {
            showError('Some Thing Wrong', setUpdateOrder.error.data.msg)
            setUpdateOrder.reset()

        }

    }, [setUpdateOrder])
    return (
        <>
            <Dialog
                open={update != null}
                onClose={() => { setUpdate(null) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>
                    <Typography variant='h4'>Update Order</Typography>
                </DialogTitle>
                <DialogContent>

                    <br />
                    <br />
                    <form onSubmit={handleSubmit(onUpdateOrdre)}>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-end', marginBottom: "20px" }}>
                                    <TextField fullWidth id="input-with-sx" label="remark" variant="standard" {...register("remark", { required: 'remark' })} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name='status'
                                    fullWidth
                                    select
                                    label="Select status"
                                    {...register("status", { required: 'select status ' })}

                                    SelectProps={{
                                        native: true,
                                    }}
                                    variant="standard"
                                >
                                    <option value={'WAT'}>Waiting</option>
                                    <option value={'COF'}>ConForm</option>
                                    <option value={'PRE'}>PreParing</option>
                                    <option value={'RDY'}>Ready</option>
                                    <option value={'OUT'}>Out For Delivery</option>
                                    <option value={'DEL'}>Delivered</option>
                                    <option value={'CAN'}>Canceled</option>
                                    <option value={'SCH'}>ScheDuled</option>

                                </TextField>
                            </Grid>
                        </Grid>





                        <DialogActions>
                            <Button type="submit" >
                                Update
                            </Button>
                            <Button onClick={() => { setUpdate(null) }}>Cancel</Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog >
        </>
    )
}

export default UpdateOrders
